export function keywordsNormalizer(keywords: Array<string>): Array<string> {
  return keywords.map((e) => e.toLowerCase().trim()).filter((value, index, self) => self.indexOf(value) === index);
}
